import {Component, OnInit, OnDestroy} from '@angular/core';
import { ActivatedRoute, Router, Params} from '@angular/router';
import { ScoreboardService } from "../services/scoreboard.service";
import { SocketService } from "../services/socket.service";
import { HelperService } from '../services/helper.service';

@Component({
  selector: 'app-qsleaderbaord',
  templateUrl: './qsleaderbaord.component.html',
  styleUrls: ['./qsleaderbaord.component.css']
})
export class QsleaderbaordComponent implements OnInit, OnDestroy {

  routeParams;
  results;
  connection;
  noData = true;
  messageDate;
  teams;
  events;
  colors;
  constructor(private route: ActivatedRoute, private router: Router,
          private ss: ScoreboardService, private helper: HelperService, private socketService: SocketService) { }

  ngOnInit() {
    this.routeParams = this.route.params
      .subscribe((params: Params) => {
        this.socketService.sendTopic(+params['id']);
        this.results = this.ss
          .getLastScoreboardData(+params['id'])
          .subscribe(message => {
            this.connection = this.socketService.messages().subscribe(message => {
              this.noData = false;
              if(message['app'] !== 'qsleaderboard'){
                this.helper.redirectToComponent(message, this.router, params);
              }else{
                this.setData(message);
              }
            });
            if(!this.helper.isEmpty(message)){
              if(message['app'] !== 'qsleaderboard'){
                this.helper.redirectToComponent(message, this.router, params);
              }
              this.setData(message);
              this.noData = false;
            }
          });
      });




  }


  ngOnDestroy(): void {
    this.connection.unsubscribe();
    this.results.unsubscribe();
    this.routeParams.unsubscribe();
  }

  getColorsBG (id) {
    return `rgb(${this.colors.find(_=> _.id === id).bgColor})`;
  }

  getColorsFG (id) {
    return `rgb(${this.colors.find(_=> _.id === id).fgColor})`;
  }

  setData (message){
    this.messageDate = message['date'];
    this.colors = message['data']['systemColors'];
    this.events = message['data']['events'];
    this.teams = message['data']['standingData']['teams'];
  }

}



// WEBPACK FOOTER //
// ./src/app/qsleaderbaord/qsleaderbaord.component.ts